import { readIdToken } from '../libs/auth'
import * as types from './actionTypes'

export const loginAction = payload => ({
  type: types.LOGIN,
  payload,
})

export const refreshTokenAction = (payload, skipLoading) => ({
  type: types.REFRESH_TOKEN,
  payload: {
    ...payload,
    skipLoading,
  },
})

export const logoutAction = () => ({
  type: types.LOGOUT,
  payload: { idToken: readIdToken().idToken },
})

export const vendorLoginAction = payload => ({
  type: types.VENDOR_LOGIN,
  payload,
})

export const cleanVendorLoginAction = payload => ({
  type: types.CLEAN_VENDOR_LOGIN,
  payload,
})
